import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import FirebaseMyAccountFunctionsService
    from "../../../../services/firebase/functions/FirebaseMyAccountFunctionsService";
import { IPlan } from "../../../../../../shared/src/functions/membersApi/types/IUserAccountFuncResponse";
import {
    IDeferPaymentRequest,
    IMarkNotificationRequest
} from "shared/functions/membersApi/types/IUserAccountFuncResponse";
import MixPanelAnalyticsService from "../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsAccountEvents} from "../../../../services/Analytics/AnalyticsAccountEvents";

export default class AccountUserStore extends ApiCallObservable<any> {

    public selectedPlan : IPlan | undefined;

    public async fetch(adminRequestedUid : string | undefined) {
        try {
            this.setSending();

            let response = {} as any;
            adminRequestedUid ?
                response = await FirebaseMyAccountFunctionsService.getOtherUserAccount(adminRequestedUid) :
                response = await FirebaseMyAccountFunctionsService.getApplications();

            if (response.ok && response.data) {
                this.setSuccessfulResponse(response.data);
            } else {
                console.log(response);
                this.setError("Failed fetching summary");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    }

    public async deferPayment(planId : string) {
        try {
            const params: IDeferPaymentRequest = {
                planId
            };
            const response = await FirebaseMyAccountFunctionsService.deferPayment(params);
            if (!response.ok)  {
                console.log(response);
                this.setError("Failed fetching summary");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    }

    public async updateSeenNotification(notificationID: string) {
        const params: IMarkNotificationRequest = {
            notificationId: notificationID
        };
        try {
            MixPanelAnalyticsService.track(AnalyticsAccountEvents.notificationOpened);
            const response = await FirebaseMyAccountFunctionsService.markNotificationAsSeen(params);
            if (!response.ok)  {
                console.log(response);
                this.setError("Failed fetching summary");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    }
}



// WEBPACK FOOTER //
// ./src/scenes/MyAccount/state/mobx/AccountUserStore.ts